import { getRequestGateway } from '@/services/api.service'
import * as Sentry from '@sentry/browser'
let aborter = null

export async function getAllComplexesGeoJSONv1(cancelPendingRequest, timeout) {
  try {
    const complexes = {
      type: 'geojson',
      data: {
        id: 'all-complexes',
        type: 'FeatureCollection',
        features: []
      },
      cluster: true,
      clusterMaxZoom: 11,
      clusterRadius: 30
    }
    if (cancelPendingRequest && aborter) aborter.abort()
    const response = await getRequestGateway('core/v1/complexes', timeout)
    const allComplexes = response.data
    allComplexes.forEach((el) => {
      // Markers are only added if the complex has a centre coordinate
      if (el.location) {
        complexes.data.features.push({
          type: 'Feature',
          id: el.id,
          geometry: {
            type: 'Point',
            coordinates: el.location.coordinates.slice(0, 2)
          },
          properties: {
            belongsToId: el.id,
            externalComplexId: el.externalId,
            title: el.displayName,
            displayName: el.displayName
          }
        })
      }
    })
    return complexes
  } catch (e) {
    console.error(e)
    Sentry.captureException(e)
    throw new Error('Could not fetch complexes')
  }
}
